import { FunctionComponent } from 'react'

import { LiveEventDataSportTypes } from '@utils/formatters/liveEvent'
import { validMatchId } from '@hooks/useSportsEvent'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import RefereeInfoComponent from '@components/RefereeInfo'

export interface RefereeInfoProps {
  title: string
  matchId: string
  typeOfSport: LiveEventDataSportTypes
}

const RefereeInfo: FunctionComponent<RefereeInfoProps> = ({
  title,
  typeOfSport,
  matchId,
}) => {
  if (!validMatchId(matchId)) {
    return null
  }
  if (typeOfSport !== 'soccer') {
    return null
  }

  return (
    <RefereeInfoComponent
      title={title}
      typeOfSport={typeOfSport}
      matchId={matchId}
    />
  )
}

const widget = {
  kind: ['referee-info'],
  component: RefereeInfo,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
